<template>
    <v-dialog v-model="isUserDialogVisibleProxy"  width="600px">
      <v-card>
        <v-card-title>{{ isEditMode ? 'Editar usuario' : 'Crear nuevo usuario' }}</v-card-title>
        <v-card-text>
          <v-form ref="IsUserFormValid" @submit.prevent="submitUser()" v-model="IsUserFormValid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="userData.displayName" label="Nombres" required outlined />
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="userData.email" label="Email" required outlined />
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="userData.perfil"
                    :items="profiles"
                    item-text="Perfil"
                    item-value="id"
                    label="Perfil"
                    outlined
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-if ="!isEditMode"
                    v-model="userData.password"
                    label="Contraseña"
                    outlined
                    type="password"
                    :required="!isEditMode"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="isUserDialogVisibleProxy = false">Cerrar</v-btn>
          <v-btn
            :disabled="!IsUserFormValid"
            color="blue darken-1"
            text
            :loading="isUserButtonLoading"
            @click=submitUser()
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'FormularioUsuarios',
    props: {
        isEditMode: {
            type: Boolean,
            required: true
        },
        isUserDialogVisible: {
            type: Boolean,
            required: true
        },
        userData: {
            type: Object,
            required: true
        },
        profiles: {
            type: Array,
            required: true
        },
        isUserButtonLoading: {
            type: Boolean,
            required: true
        },
        IsUserFormValid:{
            type: Boolean,
            required: true
        }
    },
    computed:{
        isUserDialogVisibleProxy:{
            get(){
                return this.isUserDialogVisible
            },
            set(newValue){
                this.$emit("update:isUserDialogVisible", newValue)
            }
        }
    },
    methods: {
        submitUser() {
            this.$emit('submit-user');
        }
    },
    emits: ["update:isUserDialogVisible","update:IsUserFormValid",'submit-user'],

}
</script>